import {selectLocationsType} from "./Location";

const requestWorkOrdersType = "REQUEST_WORKORDERS";
const requestScheduledType = "REQUEST_SCHEDULED";
const requestQuotesType = "REQUEST_QUOTES";
const requestInvoicesType = "REQUEST_INVOICES";
export const selectActionType = "SELECT_ACTIONS";
const setLocationType = "SET_NEW_LOCATION";

const scheduled = "scheduled";
const pastWOs = "pastWOs";
const quotes = "quotes";
const invoices = "invoices";

const initialState ={
  currentLocationId: "",
  activeTab: scheduled,
  pastWOs: [],
  scheduled: [],
  quotes: [],
  invoices: []
};

//
// Base API calls
//
async function apiGet(url, getState){
  let objectReturned;
  const response = await fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  }).then((response) => {
    if (response.status !== 200) {
      objectReturned = [];
    } else{
      objectReturned = response.json();
    }
  })
    .catch((error) =>{
      throw error;
    });
  

  return objectReturned;
}

//
// Actions
//
export const actionCreators = {
  setLocation: id => async (dispatch, getState) => {
  
    const url = `api/ticklers/location/${id}`;
    let activeTab = scheduled;
    
    dispatch({type: setLocationType, id, activeTab});
    
  },
  setTicklers: id => async (dispatch, getState) => {
    const url = `api/ticklers/location/${id}`;
    const activeTab = scheduled;
    
    let list = await apiGet(url, getState);
    
    dispatch({type: requestScheduledType, list, activeTab})
  },
  setInvoices: () => async (dispatch, getState) => {
    let location = getState().locationDetail.currentLocationId;
    const url = `api/invoices/location/${location}`;
    const activeTab = invoices;
    
    let list = await apiGet(url, getState);

    dispatch({type: requestInvoicesType, list, activeTab})
  },
  setQuotes: () => async (dispatch, getState) => {
    let location = getState().locationDetail.currentLocationId;
    const url = `api/quotes/location/${location}`;
    const activeTab = quotes;
    
    let list = await apiGet(url, getState);
    
    dispatch({type: requestQuotesType, list, activeTab})
  },
  setWorkOrders: () => async (dispatch, getState) => {
    let location = getState().locationDetail.currentLocationId;
    const url = `api/workorders/location/${location}`;
    const activeTab = pastWOs;
    
    let list = await apiGet(url, getState);

    dispatch({type: requestWorkOrdersType, list, activeTab})
  },
};

//
// Reducer
//
export const reducer = (previousState, action) => {
  previousState = previousState || initialState;

  if (action.type === setLocationType){
    return {
      ...initialState,
      currentLocationId: action.id,
      activeTab: action.activeTab,
    }
  } else if (action.type === requestScheduledType){
    return {
      ...previousState,
      scheduled: action.list,
      activeTab: action.activeTab
    }
  } else if (action.type === requestInvoicesType){
    return {
      ...previousState,
      invoices: action.list,
      activeTab: action.activeTab
    }
  } else if (action.type === requestQuotesType){
    return {
      ...previousState,
      quotes: action.list,
      activeTab: action.activeTab
    }
  } else if (action.type === requestWorkOrdersType){
    return {
      ...previousState,
      pastWOs: action.list,
      activeTab: action.activeTab
    }
  }


  return previousState;
};